import WarningIcon from "@/assets/colorable/warning.svg?react";
import ConfirmationModal from "@/components/Common/ConfirmationModal";
import {useSettingsAgencyStore} from "@/store/agency";
import {useSettingsCompanyStore} from "@/store/company";
import {discardSettingsChangesModalAtom, settingsModalAtom} from "@/store/jotaiAtoms";
import {useAtom, useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const DiscardSettingsChangesModal: FC = () => {
  const {t} = useTranslation("settings");
  const [modalData, setModalData] = useAtom(discardSettingsChangesModalAtom);
  const setSettingsModal = useSetAtom(settingsModalAtom);
  const discardCompanyChanges = useSettingsCompanyStore(state => state.discardChanges);
  const discardAgencyChanges = useSettingsAgencyStore(state => state.discardChanges);

  return (
    <ConfirmationModal
      Icon={WarningIcon}
      cancelButtonText={t("discard_changes")}
      confirmButtonText={t("keep_editing")}
      description={t("unsaved_changes_description")}
      onCancelButtonClick={() => {
        discardCompanyChanges();
        discardAgencyChanges();
        setSettingsModal(modalData!.target);
        setModalData(null);
      }}
      onClose={() => setModalData(null)}
      onConfirm={() => setModalData(null)}
      title={t("unsaved_changes_title")}
      tone="warning"
    />
  );
};

export default DiscardSettingsChangesModal;
